import React, {Component} from "react"
import {connect} from "react-redux"
import {queryCogoLandUsersWithStatus} from "../../dispatch"
import PageHeader from "../../components/PageHeader"
import PageBody from "../../components/PageBody"
import IBox from "../../components/IBox"
import UsersWithStatusTable from "./component/UsersWithStatusTable"
import UserProfileModal from "../enterprise/dashboard/components/UserProfileModal"
import {injectIntl} from "react-intl"


function mapStateToProps(state, ownProps) {

  const user = state.user
  const usersWithStatus = state.usersWithStatus
  return {
    user,usersWithStatus
  }
}

const mapDispatchToProps = {
  queryCogoLandUsersWithStatus

}

class DashboardView extends Component {

  constructor() {
    super()
    this.state = {

      userModalOpen: false,
      selectedUserId: null,

    }

  }

  componentWillMount(){

    const accountId = this.props.user.currentEnterpriseAccount.id
    this.props.queryCogoLandUsersWithStatus(accountId)

  }

  openModal = (userId) => {
    this.setState({userProfileModalOpen: true, selectedUserId: userId})
  }
  closeModal = () => {
    this.setState({userProfileModalOpen: false})
  }

  render() {
    const format = this.props.intl.formatMessage
    const users = this.props.usersWithStatus.data
    return (
      <div>

        <UserProfileModal
          userId={this.state.selectedUserId}
          show={this.state.userProfileModalOpen}
          onHide={this.closeModal}
        />

        <PageHeader pageTitle={format({id:'nav.dashboard'})}/>
        <PageBody>
          <IBox>
            <UsersWithStatusTable data={users} onSelect={(id)=>{this.openModal(id)}}/>
          </IBox>
        </PageBody>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(DashboardView))



// WEBPACK FOOTER //
// ./src/routes/cogoland/DashboardView.js